import styled, { css } from 'styled-components';
import { darken } from 'polished';

export const Container = styled.tr`
  td {
    padding: 15px 0;
    border-top: 1px solid rgba(255, 255, 255, 0.17);

    & + td {
      text-align: right;
    }
  }

  ${props =>
    props.isDragging &&
    css`
      border: 2px dashed rgba(255, 255, 255, 0.17);
      background: transparent;
      td {
        opacity: 0;
      }
      cursor: grabbing;
    `}
`;

export const BtAcao = styled.button`
  background: ${props => (props.inativo === 1 ? '#ec4561' : '#626ed4')};
  display: flex;
  justify-content: center;
  align-items: center;
  border: 0;
  padding: 7px 15px;
  color: #fff;
  border-radius: 4px;
  transition: background 0.2s;

  ${props =>
    props.inativo === 1
      ? css`
          &:hover {
            background: ${darken(0.04, '#ec4561')};
          }
        `
      : css`
          &:hover {
            background: ${darken(0.04, '#626ed4')};
          }
        `}

  & + button {
    margin-left: 10px;
  }
`;

export const Block = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

export const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  align-self: stretch;
  text-align: center;

  span {
    color: #fff;
    padding: 10px 0;
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 20px;
  }
`;

export const ModalMenus = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    flex: 1;
    background: #626ed4;
    border: 0;
    padding: 15px 0;
    border-radius: 4px;
    color: #fff;

    & + button {
      margin-left: 10px;
      background: #ec4561;
    }
  }
`;
